import React from 'react';
import { SCORECARD_EXAMPLE } from '../../../data/exampleReviews';
import { ExampleFrame } from '../../examples/ExampleFrame';
import { cn } from '../../../src/lib/utils';
export function ApplicationScorecard() {
  return <ExampleFrame title="Reviewer scorecard" subtitle="Climate resilience grant · shared rubric" caption="Fictional applicants and sample scores." data-id="element-1370" data-mp="2lua46icu18nk">
      <div className="grid gap-4 sm:grid-cols-2" data-id="element-1371" data-mp="2undqzh9daxuv">
        <div className="rounded-xl border border-hairline-soft p-3.5" data-id="element-1372" data-mp="2umkes0rn3g5c">
          <div className="flex items-center justify-between" data-id="element-1373" data-mp="2zlxbrec863ln">
            <p className="text-sm font-semibold text-text-primary" data-id="element-1374" data-mp="2zo9tbqe2mby6">{SCORECARD_EXAMPLE.applicant}</p>
            <span className="rounded-md bg-[#E8F6EE] px-1.5 py-0.5 text-[11px] font-semibold text-[#1E7A46]" data-id="element-1375" data-mp="34jp4gakp1tqw">Eligible</span>
          </div>
          <ul className="mt-3 flex flex-col gap-2.5" data-id="element-1376" data-mp="1a8adjqfy5o9k">
            {SCORECARD_EXAMPLE.rubric.map(row => <li key={row.criterion} data-id="element-1377" data-mp="1f7n0eb6tivc5">
                <div className="flex justify-between text-xs" data-id="element-1378" data-mp="1f8ppqeohsppy">
                  <span className="text-text-secondary" data-id="element-1379" data-mp="emg9rn5ttqpx">{row.criterion}</span>
                  <span className="font-mono font-semibold text-text-primary" data-id="element-1380" data-mp="9u6edrlxzyg9">
                    {row.score}/{SCORECARD_EXAMPLE.max}
                  </span>
                </div>
                <div className="mt-1 h-1.5 overflow-hidden rounded-full bg-elevated" aria-hidden="true" data-id="element-1381" data-mp="3w1whjuz6armb">
                  <div className="h-full rounded-full bg-lime" style={{
                width: `${row.score / SCORECARD_EXAMPLE.max * 100}%`
              }} data-id="element-1382" data-mp="xk0po4qm5eye" />
                </div>
              </li>)}
          </ul>
        </div>
        <div data-id="element-1383" data-mp="nljt8s8wo84y">
          <p className="text-[11px] font-semibold uppercase tracking-[0.1em] text-text-tertiary" data-id="element-1384" data-mp="nl1spjf7n7r8">Shortlist</p>
          <ol className="mt-2 flex flex-col gap-2" data-id="element-1385" data-mp="jjpz72t7u2dr">
            {SCORECARD_EXAMPLE.shortlist.map((entry, index) => <li key={entry.name} className={cn('rounded-xl border px-3 py-2.5', index === 0 ? 'border-lime/30 bg-violet-soft' : 'border-hairline-soft')} data-id="element-1386" data-mp="38dn4pijxte7b" data-mpi={index}>
                <div className="flex items-center justify-between gap-2" data-id="element-1387" data-mp="35rmf1uc89rlm">
                  <p className="text-sm font-semibold text-text-primary" data-id="element-1388" data-mp="3aqp8ehiui9dr">{entry.name}</p>
                  <span className="font-mono text-xs font-semibold text-lime" data-id="element-1389" data-mp="2vtq535v112p3">{entry.total}/20</span>
                </div>
                <p className="mt-0.5 text-xs text-text-secondary" data-id="element-1390" data-mp="30s9qn55pkcgx">Why: {entry.reason}</p>
              </li>)}
          </ol>
        </div>
      </div>
    </ExampleFrame>;
}